var _path, _path2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIgreenicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.311 18.1333V14.6488C15.311 13.9555 15.873 13.3936 16.5662 13.3936C17.2594 13.3936 17.8214 13.9555 17.8214 14.6488V23.154C17.8214 23.8472 17.2594 24.4091 16.5662 24.4091C15.873 24.4091 15.311 23.8472 15.311 23.154V18.1333ZM15.311 9.97465C15.311 9.28144 15.873 8.71948 16.5662 8.71948C17.2594 8.71948 17.8214 9.28144 17.8214 9.97466V10.1567C17.8214 10.8499 17.2594 11.4119 16.5662 11.4119C15.873 11.4119 15.311 10.8499 15.311 10.1567V9.97465Z",
    fill: "#219653"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 30.819C24.5462 30.819 31.069 24.2962 31.069 16.25C31.069 8.20378 24.5462 1.68103 16.5 1.68103C8.45378 1.68103 1.93103 8.20378 1.93103 16.25C1.93103 24.2962 8.45378 30.819 16.5 30.819ZM16.5 32.5C25.4746 32.5 32.75 25.2246 32.75 16.25C32.75 7.27537 25.4746 0 16.5 0C7.52537 0 0.25 7.27537 0.25 16.25C0.25 25.2246 7.52537 32.5 16.5 32.5Z",
    fill: "#219653"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIgreenicon);
export default __webpack_public_path__ + "static/media/igreenicon.38e2f59f98166e076eb51d88a3d7d46b.svg";
export { ForwardRef as ReactComponent };